import { BaseLoginResponse } from "../../../response/seguridad/BaseLoginResponse";
import { LoginPayload } from "../../../services/api/payload/seguridad/LoginPayload";
import { errorMessageComponent } from "../../error/ErrorMessageComponent";
import { BaseCreateComponent } from "../../BaseCreateComponent";
import { InputTextComponent } from "../../form/inputs/InputTextComponent";
import template from "./template.html";

export class LoginComponent<
  TLoginResponse extends BaseLoginResponse,
> extends BaseCreateComponent<HTMLDivElement> {
  constructor(
    /** Inyectado por cada app (hoy gRPC para Plataforma; ver `PlataformaInit.ts`) — este
     *  componente no sabe de qué transporte viene la respuesta. */
    private readonly _login: (email: string, password: string) => Promise<TLoginResponse>,
    private readonly _logoRoute: string,
    private readonly _payload: LoginPayload,
    private readonly _onSubmitEnd: (response: TLoginResponse) => void,
  ) {
    super();
  }

  protected getTagName(): string {
    return "div";
  }

  protected getElementId(): string {
    return "loginWrapper";
  }

  protected override afterInit(element: HTMLDivElement): void {
    element.innerHTML = this.createHtmlString(template, {
      logoRoute: this._logoRoute,
    });

    const payload = this._payload;

    const emailInput = new InputTextComponent(
      element.querySelector<HTMLElement>("#loginEmailField")!,
      {
        label: "Email",
        isRequired: true,
        isEmail: true,
        isPassword: false,
        minLength: null,
        maxLength: null,
        icon: "ph-envelope",
        value: payload.email,
        onChange: (v) => (payload.email = v),
      },
    );

    const passwordInput = new InputTextComponent(
      element.querySelector<HTMLElement>("#loginPasswordField")!,
      {
        label: "Contraseña",
        isRequired: true,
        isEmail: false,
        isPassword: true,
        minLength: null,
        maxLength: null,
        icon: "ph-lock",
        value: payload.password,
        onChange: (v) => (payload.password = v),
      },
    );

    const fields = [emailInput, passwordInput];
    fields.forEach((f) => f.init());

    const button = element.querySelector<HTMLButtonElement>(".btn-submit")!;

    button.onclick = async () => {
      fields.forEach((f) => f.showError());
      const firstInvalid = fields.find((f) => f.getError() !== null);
      if (firstInvalid) {
        firstInvalid.focus();
        return;
      }

      button.disabled = true;
      fields.forEach((f) => f.disabled());

      try {
        const response = await this._login(payload.email, payload.password);
        this._onSubmitEnd(response);
      } catch (error) {
        errorMessageComponent.addError(
          "Error al Ingresar",
          error instanceof Error ? error.message : "Error desconocido",
        );
        button.disabled = false;
        fields.forEach((f) => f.enabled());
      }
    };
  }
}
